<ng-template [ngIf]="isAvailableStatistics">
  <ng-template [ngIf]="displayMode === 'default'" [ngIfElse]="contentPage">
    <div class="share-and-stats">
      <div class="left">
        <ng-container *ngTemplateOutlet="likesWrap"></ng-container>
      </div>

      <div class="right">
        <div class="item">
          <app-icon class="icon comment" [class.active]="visit_info && visit_info.is_commented" icon="comment"></app-icon>
          <span class="value" [class.color-blue]="visit_info && visit_info.is_commented">{{ stats.comments_count }}</span>
        </div>

        <div class="item view-item">
          <app-icon class="icon shows" [class.active]="visit_info && visit_info.is_viewed" icon="shows"></app-icon>
          <span class="value"
                [class.color-light-blue]="visit_info && visit_info.is_viewed"
                [attr.data-test] = "'views-count'">
          {{ stats.views_count }}
        </span>
        </div>
      </div>
    </div>
  </ng-template>
</ng-template>

<ng-template #contentPage>
  <div class="share-and-stats-content-page">
    <ng-container *ngTemplateOutlet="likesWrap"></ng-container>
    <div class="item"
         [ngxClipboard]
         [cbContent]="url"
         (cbOnSuccess)="onCopyLink()">
      <div class="icon-wrap">
        <app-icon class="icon share" icon="share"></app-icon>
      </div>
      <span class="value">{{ 'library.menu-share' | translate }}</span>
    </div>

    <div class="item">
      <div class="icon-wrap">
        <ng-content select="[bookmark]"></ng-content>
      </div>
      <span class="value">{{ 'library.menu-bookmark' | translate }}</span>
    </div>

    <div class="item">
      <ng-content select="[menu]"></ng-content>
      <span class="value">{{ 'library.menu-more' | translate }}</span>
    </div>
  </div>
</ng-template>

<ng-template #likesWrap>
  <div class="item" (click)="isAuth ? like() : authorize()">
    <div class="icon-wrap">
      <app-icon class="icon like" [class.active]="visit_info && visit_info.is_liked" icon="thumb-up"></app-icon>
    </div>
    <span class="value" [class.color-green]="visit_info && visit_info.is_liked">{{ stats.likes_count }}</span>
  </div>
  <div class="item" (click)="isAuth ? dislike() : authorize()">
    <div class="icon-wrap">
      <app-icon class="icon dislike" [class.active]="visit_info && visit_info.is_disliked" icon="thumb-down"></app-icon>
    </div>
    <span class="value" [class.color-pink]="visit_info && visit_info.is_disliked">{{ stats.dislikes_count }}</span>
  </div>
</ng-template>
